console.log("SCRIPT_LOAD: removeBaseURL.js.lqd");

function RemoveBaseUrl(url) {
  var currentDomain = window.location.hostname; // Get the current domain
  var baseUrlPattern = /^(http|https)?:\/\/brickellmensproducts\.(com|ca|co.uk|com.au|it|de|in)/;

  var match = baseUrlPattern.exec(url);
  if (match && match[0]) {
    var protocolAndDomain = match[0]; // The full matched protocol and domain
    var newBaseUrl = "https://" + currentDomain;
    url = url.replace(protocolAndDomain, newBaseUrl); // Replace only the protocol and domain part
  }

  return url;
}

function updateLinks() {
  var articleLinks = document.querySelectorAll(".article-container a:not(.article--sidebar a)");
  articleLinks.forEach(function (link) {
    link.href = RemoveBaseUrl(link.href);
  });
}
function docReady(fn) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(updateLinks);
